import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import mp from 'images/mp.jpg';
import './index.scss';
import Cases from 'pages/index/Cases';
import Solutions from 'pages/index/Sulutions';
import Industries from 'pages/index/Industries';
import Applications from 'pages/index/Applications';
import Services from 'pages/index/Services';
import Partners from 'pages/index/Partners';
import { useHistory } from 'react-router';
// import { report } from 'store/report';
import qs from 'qs';

const siteList = [
  {
    name: '腾讯广告投放平台',
    url: 'https://ad.qq.com/',
  },
  {
    name: '腾讯广告营销学堂',
    url: 'https://edu.tencentads.com/?name=pcgw',
  },
  {
    name: '腾讯千帆云市场',
    url: 'https://market.cloud.tencent.com/',
  },
];

const IndexPage = () => {
  const [rollTopVisible, setRollTopVisible] = useState<boolean>();
  const history = useHistory();

  useEffect(() => {
    const handleScroll = () => {
      setRollTopVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
    if (query.client_id && query.from === 'amshomesgj') {
      history.replace(`/application/${query.client_id}`);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  const openYzf = () => {
    window.open(
      'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97d32600c2214498ea14b3b867f34309055de14b8dc0a1596a1c52772ca70682e18c97e443e70db8f922c8c6cb0eb8'
    );
  };

  // const jump3 = () => {
  //   report({ event: 'banner_to_tool', client_id: '1112005684' });
  //   window.open('https://isv.e.qq.com/application/1112005684/');
  // };

  return (
    <>
      <Slider autoplay dots arrows={false} infinite className="banner">
        {/* <Slider dots arrows={false} infinite className="banner">*/}
        <div className="banner-item">
          <picture>
            <source
              srcSet="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner-3.png"
              media="(min-width: 1921px)"
            />
            <img src="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner-3.png" alt="" />
          </picture>
          <div className="text left">
            <div className="text-bold title">免费发布需求功能上线</div>
            <div className="desc">帮您快速找到合适服务商！</div>
            <div>
              <a
                href="https://docs.qq.com/doc/DWXNFZ0xESnJvTHR2"
                target="_blank"
                rel="noreferrer"
                className="a-button large"
                data-track="link-banner"
              >
                立即寻找服务商
              </a>
            </div>
          </div>
        </div>
        <div className="banner-item">
          <picture>
            <source
              srcSet="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner1@2x.png"
              media="(min-width: 1921px)"
            />
            <img src="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner1.png" alt="" />
          </picture>
          <div className="text left">
            <div className="text-bold title">生态聚能 开放共赢</div>
            <div className="desc">聚合优质三方生态服务和工具，提供广告全链路解决方案</div>
            <div>
              <a
                href="https://docs.qq.com/doc/DWWxUSXJhYXZraklj"
                target="_blank"
                rel="noreferrer"
                className="a-button large"
                data-track="link-banner"
              >
                了解操作详情
              </a>
            </div>
          </div>
        </div>
        <div className="banner-item">
          <picture>
            <source
              srcSet="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner2@2x.png"
              media="(min-width: 1921px)"
            />
            <img src="https://unionplatform-75179.gzc.vod.tencent-cloud.com/webstore/banner2.png" alt="" />
          </picture>
          <div className="text left">
            <div className="leading" />
            <div className="text-bold title">邀您共建腾讯广告营销生态</div>
            <div>
              <a
                href="/regist"
                target="_blank"
                rel="noreferrer"
                className="a-button large"
                // data-track="link-banner"
              >
                立即注册成为生态伙伴
              </a>
            </div>
          </div>
        </div>

        {/* <div className="banner-item">*/}
        {/*  <picture>*/}
        {/*    <source*/}
        {/*      srcSet="https://bbx-pic.gtimg.com/bbx/pictures/2022/221_20220316103458_114475.png"*/}
        {/*      media="(min-width: 1921px)"*/}
        {/*    />*/}
        {/*    <img src="https://bbx-pic.gtimg.com/bbx/pictures/2022/221_20220316103458_114475.png" alt="" />*/}
        {/*  </picture>*/}
        {/*  <div className="text left">*/}
        {/*    <div className="text-bold title">*/}
        {/*      邀您体验「智能定制分时报表」告别周末值班*/}
        {/*      <div className="isnew">新品上线</div>*/}
        {/*    </div>*/}
        {/*    <div className="desc">跨账户统计 | 数据及时 | 自动推送 | 个性化模版 | 智能预警</div>*/}
        {/*    <div>*/}
        {/*      <a onClick={jump3} rel="noreferrer" className="a-button large">*/}
        {/*        立即体验*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/* </div>*/}
      </Slider>

      <Applications />

      <Services />

      <Industries />

      <Cases />

      <Solutions />

      <Partners />

      <section className="contact">
        <div className="content">
          <div className="text-bold slogan">营销服务市场诚邀开发者，共建开放共赢生态！</div>
          <a className="a-button large" href="/regist" target="_blank" rel="noreferrer" data-track="link-contact">
            立即合作
          </a>
        </div>
        <picture>
          <source srcSet="https://union.gdtimg.com/webstore/contact@2x.png" media="(min-width: 1921px)" />
          <img src="https://union.gdtimg.com/webstore/contact.png" alt="联系我们" />
        </picture>
      </section>

      <section className="sites">
        <div>
          <div className="title">相关链接</div>
          {siteList?.map((item) => (
            <a key={item.name} href={item.url} target="_blank" rel="noreferrer">
              {item.name}
            </a>
          ))}
        </div>
        <div>
          <div className="title">服务商</div>
          <a href="https://wj.qq.com/s2/8217102/6f93/" target="_blank" rel="noreferrer">
            用户反馈
          </a>
          <a href="https://docs.qq.com/doc/DWWxUSXJhYXZraklj" target="_blank" rel="noreferrer">
            操作手册
          </a>
          <a href="/regist" target="_blank" rel="noreferrer">
            开发者入驻
          </a>
        </div>
        <div>
          <div className="title">联系我们</div>
          <a href="mailto:AD_ISV@tencent.com" target="_blank" rel="noreferrer">
            AD_ISV@tencent.com
          </a>
          <span role="button" className="mp">
            渠道生态伙伴交流平台公众号
            <figure>
              <img src={mp} alt="渠道生态伙伴交流平台公众号" />
            </figure>
          </span>
        </div>
      </section>

      <aside className={rollTopVisible ? 'with-roll-top' : ''}>
        <div className="item consult">
          <span role="button" />
          <div className="tip-wrapper">
            <span
              style={{ cursor: 'pointer', fontWeight: 'bolder', color: '#fff', paddingBottom: '8px', width: '80px' }}
              id="yzf-btn"
              onClick={openYzf}
            >
              在线咨询
            </span>
          </div>
        </div>
        <div className="item roll-top">
          <span role="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
          <div className="tip-wrapper">返回顶部</div>
        </div>
      </aside>
    </>
  );
};

export default IndexPage;
